import React from "react";
import "../CSS/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <header className="privacy-policy-header">
        <h1 className="privacy-policy-title">Privacy Policy</h1>
        <p className="privacy-policy-subtitle">How we collect, use, and protect your information</p>
      </header>
      
      <div className="privacy-policy-content">
  
  <p>Last updated: September 10, 2025</p>

  <p>This Privacy Policy explains how we collect, use, disclose, and protect information in connection with our websites, applications, and related services (collectively, the “Services”). This policy is designed to be general and may be adapted for different jurisdictions. By using the Services, you agree to the collection and use of information in accordance with this policy.</p>

  <h4>1. Information We Collect</h4>
  <p>We may collect information that you provide directly to us, information collected automatically when you use the Services, and information from third parties. This may include:</p>
  <ul>
    <li>Account and contact information (e.g., name, email address, password)</li>
    <li>Profile information (e.g., preferences, settings)</li>
    <li>Usage and device information (e.g., IP address, browser type, pages viewed, referring/exit pages, timestamps)</li>
    <li>Cookies and similar technologies (see “Cookies and Tracking” below)</li>
    <li>Payment-related information processed by our payment providers (we do not store full payment card details)</li>
  </ul>

  <h4>2. How We Use Information</h4>
  <p>We use the information we collect to:</p>
  <ul>
    <li>Provide, operate, maintain, and improve the Services</li>
    <li>Personalize your experience and deliver relevant content</li>
    <li>Communicate with you about the Services, including updates and administrative messages</li>
    <li>Process transactions and fulfill requests</li>
    <li>Monitor and analyze trends, usage, and activities</li>
    <li>Detect, prevent, and address technical issues and security incidents</li>
    <li>Comply with legal obligations and enforce our terms</li>
  </ul>

  <h4>3. Legal Bases for Processing (EEA/UK users)</h4>
  <p>Where applicable, we process personal data on the following legal bases: (i) to perform a contract with you; (ii) with your consent; (iii) for our legitimate interests (e.g., to improve the Services); and (iv) to comply with legal obligations.</p>

  <h4>4. Sharing of Information</h4>
  <p>We may share information with trusted third parties who provide services on our behalf, such as hosting, analytics, customer support, and payment processing. We may also disclose information: (i) to comply with applicable law or legal process; (ii) to protect the rights and safety of us, our users, or others; or (iii) in connection with a merger, sale, or asset transfer. We do not sell your personal information.</p>

  <h4>5. Cookies and Tracking</h4>
  <p>We use cookies, web beacons, and similar technologies to operate and improve the Services, understand usage, and personalize content. You can control cookies through your browser settings and other tools. For more information, please see our Cookie Policy.</p>

  <h4>6. Data Retention</h4>
  <p>We retain information for as long as necessary to provide the Services, comply with our legal obligations, resolve disputes, and enforce our agreements. Retention periods may vary depending on the type of data and our obligations.</p>

  <h4>7. Data Security</h4>
  <p>We implement reasonable administrative, technical, and physical safeguards to protect information. However, no method of transmission over the Internet or method of electronic storage is completely secure.</p>

  <h4>8. Your Rights and Choices</h4>
  <p>Depending on your location, you may have rights regarding your personal information, such as the right to access, correct, delete, or restrict processing of your data, and to object to certain processing or request data portability. You may also withdraw consent where processing is based on consent. To exercise these rights, contact us using the information below.</p>

  <h4>9. International Data Transfers</h4>
  <p>Your information may be transferred to and processed in countries other than the country in which you reside. We take steps to ensure appropriate safeguards are in place when transferring personal data internationally.</p>

  <h4>10. Children’s Privacy</h4>
  <p>The Services are not directed to children under 13 (or other age as required by local law), and we do not knowingly collect personal information from children.</p>

  <h4>11. Changes to This Policy</h4>
  <p>We may update this Privacy Policy from time to time. If we make material changes, we will notify you by updating the “Last updated” date and, where appropriate, by additional means.</p>

  <h4>12. Contact Us</h4>
  <p>If you have questions about this Privacy Policy or our data practices, contact us at: <strong>support@example.com</strong></p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
